// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"382f1d5b","356":"3dc815d3","438":"f1ecdc79","465":"ad72a87b","538":"24c5e331","912":"b32f7f94","954":"90342d58"}[chunkId] + ".chunk.js";
};